import 'typeface-roboto-slab';

import '@/theme/animosa.css';

export const fonts = {
  body: 'Roboto Slab, serif',
  heading: 'Animosa, sans-serif',
};
